import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContactSalesModule } from '@nk/shared/components/contact-sales/contact-sales.module';
import { SharedModule } from '@nk/shared/shared.module';
import { ButtonDirective, ClickOutsideDirective } from '@nk/ui-lib';
import { CountryFocusItemsDropdownComponent } from './country-focus-items-dropdown/country-focus-items-dropdown.component';
import { CountryFocusItemsComponent } from './country-focus-items/country-focus-items.component';

@NgModule({
  declarations: [CountryFocusItemsComponent, CountryFocusItemsDropdownComponent],
  exports: [CountryFocusItemsComponent],
  imports: [CommonModule, SharedModule, ClickOutsideDirective, ContactSalesModule, ButtonDirective],
})
export class CountryFocusItemsModule {}
